import { HeadlessUiComboboxOption } from '@festina-life/ui/forms'
import { Icon, typographyStyles } from '@festina-life/ui/structure'
import cx from 'classnames'

import { Option } from './Option'
import type {
  RankedItem,
  RenderedCategory,
  SearchableItemCategory,
  SearchableItemGroup,
} from './types'

const getOptionKey = (
  option: SearchableItemCategory[number],
  category: string,
) =>
  `${category}.${option.isWorkflow}.${typeof option.action === 'string' ? option.action : option.title}`

type Props = {
  category: RenderedCategory | null
  items: RankedItem[]
  group: SearchableItemGroup
}

export const Category = ({ category, items, group }: Props) => (
  <>
    {category && (
      <HeadlessUiComboboxOption
        value={null}
        disabled
        className={cx(
          'flex items-center gap-2 px-2 py-1.5 uppercase',
          typographyStyles({
            intensity: 'secondary',
            size: 'sm',
            weight: 'bold',
          }),
        )}
      >
        {category.Icon && <Icon name={category.Icon} size="md" />}
        {category.label}
      </HeadlessUiComboboxOption>
    )}
    {Object.values(items).map((option) => (
      <Option
        key={getOptionKey(option, category?.label ?? '')}
        value={option}
        comboboxId={getOptionKey(option, category?.label ?? '')}
        group={group}
      />
    ))}
  </>
)
